import gqlApi from '../../api/gql'

// initial state
const state = () => ({
  courseTeachers: [],
  courseTeachersUiMeta: [],
  courseTeacher: {},

  courseCategories: [],
  courseCategoriesUiMeta: [],
  courseCategory: {},

  courses: [],
  coursesUiMeta: [],
  course: {},

  courseTeacherOpenSlots: [],

  courseOrders: [],
  courseOrdersUiMeta: [],
  courseOrder: {},
  courseConfirmedTimesOrders: [],
  courseUnconfirmedOrdersUiMeta: [],
  courseUnconfirmedOrders: [],
  courseUnconfirmedOrder: {},
})

// getters
const getters = {}

// actions
const actions = {
  listCourseTeachers({ commit, state }) {
    return gqlApi.query({
      query: `
        query($name: String!){
          GetUiMeta(name: $name, filterInvisible: true){
            key
            label
          }
          ListCourseTeachers{
            created_at
            invisible_id
            name
            i18n_status
            updated_at
          }
        }
      `,
      variables: {
        name: 'CourseTeacherListVo',
      },
    }).then(data => {
      commit('set', ['courseTeachersUiMeta', data.GetUiMeta])
      commit('setCourseTeachers', data.ListCourseTeachers)
      return true
    })
  },
  getCourseTeacher({ commit, state }, id) {
    return gqlApi.query({
      query: `
        query($id: String!){
          GetCourseTeacher(id: $id){
            created_at
            id
            name
            status
            updated_at
          }
        }
      `,
      variables: {
        id,
      },
    }).then(resp => {
      commit('setCourseTeacher', resp.GetCourseTeacher)
      return true
    })
  },
  updateCourseTeacher(_, courseTeacher) {
    return gqlApi.query({
      query: `    
        mutation($input: CourseTeacherUpdateVo){
          UpdateCourseTeacher(input: $input){
            id
          }
        }
      `,
      variables: {
        input: courseTeacher,
      },
    }).then(() => {
      return true
    })
  },
  addCourseTeacher(_, courseTeacher) {
    return gqlApi.query({
      query: `    
        mutation($input: CourseTeacherAddVo){
          AddCourseTeacher(input: $input){
            id
          }
        }
      `,
      variables: {
        input: courseTeacher,
      },
    }).then(() => {
      return true
    })
  },
  deleteCourseTeacher(_, id) {
    return gqlApi.query({
      query: `    
        mutation($id: String){
          DeleteCourseTeacher(id: $id)
        }
      `,
      variables: {  
        id: id,
      },
    }).then(() => {
      return true
    })
  },
  
  listCourseCategories({ commit, state }) {
    return gqlApi.query({
      query: `
        query($name: String!){
          GetUiMeta(name: $name, filterInvisible: true){
            key
            label
          }
          ListCourseCategories{
            invisible_id
            name
            image_url
            sequence
            i18n_status
            created_at
            updated_at
          }
        }
      `,
      variables: {
        name: 'CourseCategoryListVo',
      }
    }).then(data => {
      commit('set', ['courseCategoriesUiMeta', data.GetUiMeta])
      commit('setCourseCategories', data.ListCourseCategories)
      return true
    })
  },

  getCourseCategory({ commit, state }, id) {
    return gqlApi.query({
      query: `
        query($id: String!){
          GetCourseCategory(id: $id){
            created_at
            description
            id
            image_url
            name
            parent_id
            sequence
            status
            updated_at
          }
        }
      `,
      variables: {
        id,
      },
    }).then(resp => {
      commit('setCourseCategory', resp.GetCourseCategory)
      return true
    })
  },

  updateCourseCategory(_, courseCategory) {
    return gqlApi.query({
      query: `    
        mutation($input: CourseCategoryUpdateVo){
          UpdateCourseCategory(input: $input){
            id
          }
        }
      `,
      variables: {
        input: courseCategory,
      },
    }).then(() => {
      return true
    })
  },

  addCourseCategory(_, courseCategory) {
    return gqlApi.query({
      query: `    
        mutation($input: CourseCategoryAddVo){
          AddCourseCategory(input: $input){
            id
          }
        }
      `,
      variables: {
        input: courseCategory,
      },
    }).then(() => {
      return true
    })
  },

  deleteCourseCategory(_, id) {
    return gqlApi.query({
      query: `    
        mutation($id: String){
          DeleteCourseCategory(id: $id)
        }
      `,
      variables: {  
        id: id,
      },
    }).then(() => {
      return true
    })
  },

  listCourses({ commit, state }) {
    return gqlApi.query({
      query: `
        query($name: String!){
          GetUiMeta(name: $name, filterInvisible: true){
            key
            label
          }
          ListCourses{
            invisible_id
            name
            periods
            i18n_status
            sequence
            together_course_group
            image_url
            updated_at
          }
        }
      `,
      variables: {
        name: 'CourseListVo',
      }
    }).then(data => {
      commit('set', ['coursesUiMeta', data.GetUiMeta])
      commit('setCourses', data.ListCourses)
      return true
    })
  },
  getCourse({ commit, state }, id) {
    return gqlApi.query({
      query: `
        query($id: String!){
          GetCourse(id: $id){
            category_id
            created_at
            desc_html
            desc_style
            id
            image_urls
            name
            periods
            price
            status
            course_teacher_id,
            sequence
            together_course_group
            updated_at
          }
        }
      `,
      variables: {
        id,
      },
    }).then(resp => {
      commit('setCourse', resp.GetCourse)
      return true
    })
  },
  updateCourse(_, course) {
    return gqlApi.query({
      query: `    
        mutation($input: CourseUpdateVo){
          UpdateCourse(input: $input){
            id
          }
        }
      `,
      variables: {
        input: course,
      },
    }).then(() => {
      return true
    })
  },
  addCourse(_, course) {
    return gqlApi.query({
      query: `    
        mutation($input: CourseAddVo){
          AddCourse(input: $input){
            id
          }
        }
      `,
      variables: {
        input: course,
      },
    }).then(() => {
      return true
    })
  },
  deleteCourse(_, id) {
    return gqlApi.query({
      query: `    
        mutation($id: String){
          DeleteCourse(id: $id)
        }
      `,
      variables: {  
        id: id,
      },
    }).then(() => {
      return true
    })
  },

  listCourseTeacherOpenSlots({ commit, state }, { courseTeacherId, startTime, endTime }) {
    return gqlApi.query({
      query: `
        query($courseTeacherId: String!, $startTime: String!, $endTime: String!){
          ListCourseTeacherOpenSlots(end_time: $endTime, id: $courseTeacherId, start_time: $startTime){
            course_teacher_id
            end_time
            id
            start_time
          }
        }
      `,
      variables: {
        courseTeacherId, 
        startTime, 
        endTime,
      }
    }).then(data => {
      commit('setCourseTeacherOpenSlots', data.ListCourseTeacherOpenSlots)
      return true
    })
  },
  addOrDeleteCourseTeacherOpenSlots(_, courseTeacherAddOrDeleteOpenSlots) {
    return gqlApi.query({
      query: `    
        mutation($input: [CourseTeacherOpenSlotAddOrDeleteVo]){
          AddOrDeleteCourseTeacherOpenSlots(input: $input)
        }
      `,
      variables: {
        input: courseTeacherAddOrDeleteOpenSlots,
      },
    }).then(() => {
      return true
    })
  },

  listCourseOrders({ commit, state }) {
    return gqlApi.query({
      query: `
        query($name: String!){
          GetUiMeta(name: $name, filterInvisible: true){
            key
            label
          }
          ListCourseOrders{
            confirmed_course_name
            contact_cellphone
            contact_email
            contact_name
            i18n_status
            invisible_id
            order_no
            updated_at
          }
        }
      `,
      variables: {
        name: 'CourseOrderListVo',
      }
    }).then(data => {
      commit('set', ['courseOrdersUiMeta', data.GetUiMeta])
      commit('setCourseOrders', data.ListCourseOrders)
      return true
    })
  },
  getCourseOrder({ commit, state }, id) {
    return gqlApi.query({
      query: `
        query($id: String!){
          GetCourseOrder(id: $id){
            confirmed_course_id
            confirmed_participants_num
            confirmed_periods
            contact_cellphone
            contact_email
            contact_home_phone
            contact_name
            created_at
            id
            member_id
            order_no
            reserved_course_id
            reserved_note
            reserved_participants_num
            reserved_periods
            status
            teacher_note
            updated_at
          }
        }
      `,
      variables: {
        id,
      },
    }).then(resp => {
      commit('setCourseOrder', resp.GetCourseOrder)
      return true
    })
  },
  updateCourseOrder(_, courseOrder) {
    return gqlApi.query({
      query: `    
        mutation($input: CourseOrderUpdateVo){
          UpdateCourseOrder(input: $input){
            id
          }
        }
      `,
      variables: {
        input: courseOrder,
      },
    }).then(() => {
      return true
    })
  },
  updateCourseUnconfirmedOrder(_, { courseOrder, sendEmail }) {
    return gqlApi.query({
      query: `    
        mutation($input: CourseOrderUnconfirmedUpdateVo, $sendEmail: Boolean){
          UpdateCourseUnconfirmedOrder(input: $input, sendEmail: $sendEmail){
            id
          }
        }
      `,
      variables: {
        input: courseOrder,
        sendEmail: sendEmail === true,
      },
    }).then(() => {
      return true
    })
  },
  addCourseOrder(_, courseOrder) {
    return gqlApi.query({
      query: `    
        mutation($input: CourseOrderAddVo){
          AddCourseOrder(input: $input){
            id
          }
        }
      `,
      variables: {
        input: courseOrder,
      },
    }).then(() => {
      return true
    })
  },
  deleteCourseOrder(_, id) {
    return gqlApi.query({
      query: `    
        mutation($id: String){
          DeleteCourseOrder(id: $id)
        }
      `,
      variables: {  
        id: id,
      },
    }).then(() => {
      return true
    })
  },
  listConfirmedTimeSlotsCourserOrders({ commit, state }, { startDatetime, endDatetime }) {
    return gqlApi.query({
      query: `
        query($startDatetime: String!, $endDatetime: String!){
          ListConfirmedTimeSlotsCourserOrders(startDatetime: $startDatetime, endDatetime: $endDatetime){
            invisible_id
            order_no
            reserved_note
            confirmed_course_name
            confirmed_participants_num
            confirmed_periods
          }
        }
      `,
      variables: {
        startDatetime,
        endDatetime,
      },
    }).then(resp => {
      commit('setCourseConfirmedTimesOrders', resp.ListConfirmedTimeSlotsCourserOrders)
      return true
    })
  },
  listCourseUnconfirmedOrders({ commit, state }) {
    return gqlApi.query({
      query: `
        query($name: String!){
          GetUiMeta(name: $name, filterInvisible: true){
            key
            label
          }
          ListCourseUnconfirmedOrders{
            invisible_id
            order_no
            unconfirmed_course_detail
          }
        }
      `,
      variables: {
        name: 'CourseOrderUnconfirmedListVo',
      },
    }).then(data => {
      commit('set', ['courseUnconfirmedOrdersUiMeta', data.GetUiMeta])
      commit('setCourseUnconfirmedOrders', data.ListCourseUnconfirmedOrders)
      return true
    })
  },
  getCourseUnconfirmedOrder({ commit, state }, id) {
    return gqlApi.query({
      query: `
        query($id: String!){
          GetCourseUnconfirmedOrder(id: $id){
            invisible_id
            order_no
            teacher_note
            unconfirmed_confirmed_course_id
            unconfirmed_confirmed_participants_num
            unconfirmed_confirmed_periods
            unconfirmed_course_order_detail
          }
        }
      `,
      variables: {
        id,
      },
    }).then(resp => {
      commit('setCourseUnconfirmedOrder', resp.GetCourseUnconfirmedOrder)
      return true
    })
  },
}

// mutations
const mutations = {
  set (state, [variable, value]) {
    state[variable] = value
  },
  setCourseTeachers (state, courseTeachers) {
    state.courseTeachers = courseTeachers
  },
  setCourseTeacher (state, courseTeacher) {
    state.courseTeacher = courseTeacher
  },
  setCourseCategories (state, courseCategories) {
    state.courseCategories = courseCategories
  },
  setCourseCategory (state, courseCategory) {
    state.courseCategory = courseCategory
  },
  setCourses (state, courses) {
    state.courses = courses
  },
  setCourse (state, course) {
    state.course = course
  },
  setCourseTeacherOpenSlots (state, courseTeacherOpenSlots) {
    state.courseTeacherOpenSlots = courseTeacherOpenSlots
  },
  setCourseOrders (state, courseOrders) {
    state.courseOrders = courseOrders
  },
  setCourseConfirmedTimesOrders (state, courseOrders) {
    state.courseConfirmedTimesOrders = courseOrders
  },
  setCourseUnconfirmedOrders (state, courseOrders) {
    state.courseUnconfirmedOrders = courseOrders
  },
  setCourseUnconfirmedOrder (state, courseOrder) {
    state.courseUnconfirmedOrder = courseOrder
  },
  setCourseOrder (state, courseOrder) {
    state.courseOrder = courseOrder
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}